import { useEffect, useState } from 'react';
import axios from 'axios';

function useGetSeasonSponsors(activeSeason) {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activeSeason?.id) {
      setSponsors([]);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    // Fetch sponsors for the active season
    axios.get(`/api/leagues/sponsors/`, {
      params: { season_id: activeSeason.id },
      withCredentials: true,
    })
      .then(response => {
        if (cancelled) return;
        // Filter sponsors to only show active ones that should be displayed on website
        const activeSponsors = response.data.filter(sponsor =>
          sponsor.is_active && sponsor.display_on_website
        );
        setSponsors(activeSponsors);
      })
      .catch(error => {
        if (cancelled) return;
        console.error('Error fetching sponsors:', error);
        setError('Failed to load sponsors');
        setSponsors([]);
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [activeSeason?.id]);

  return { sponsors, loading, error };
}

export default useGetSeasonSponsors;
